import React from 'react';
import Cart from '../components/Cart';

const CartScreen = ({
  darkMode,
  cart,
  checkoutStep,
  setCheckoutStep,
  formData,
  handleFormChange,
  handleDeliveryMethodChange,
  handleSubmitOrder,
  removeFromCart,
  updateQuantity,
  calculateTotal,
  calculateDeliveryPrice,
  getPaymentMethod,
  handleCheckout,
  setActiveTab
}) => {
  return (
    <Cart
      darkMode={darkMode}
      cart={cart}
      checkoutStep={checkoutStep}
      setCheckoutStep={setCheckoutStep}
      formData={formData}
      handleFormChange={handleFormChange}
      handleDeliveryMethodChange={handleDeliveryMethodChange}
      handleSubmitOrder={handleSubmitOrder}
      removeFromCart={removeFromCart}
      updateQuantity={updateQuantity}
      calculateTotal={calculateTotal}
      calculateDeliveryPrice={calculateDeliveryPrice}
      getPaymentMethod={getPaymentMethod}
      handleCheckout={handleCheckout}
      setActiveTab={setActiveTab}
    />
  );
};

export default CartScreen;